import { useTranslation } from 'react-i18next';

const useStoreTranslation = () => useTranslation();

export default useStoreTranslation;
